import { useState } from "react";
import { isValidEmail, isValidMobileNumber } from "utils/Validators";

const BusinessDetailsTab = ({data, validation, onSave, onBack, subscriptionPlans}) => {
  const [form, setForm] = useState({
    name: data.name || "",
    subscriptionId: data.subscriptionId || "",
    contactNo: data.contactNo || "",
    email: data.email || "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (field) => (e) => {
    setForm((s) => ({ ...s, [field]: e.target.value }));
    setErrors((err) => ({ ...err, [field]: "" }));
  };

  const validate = () => {
    const err = {};
    if (!form.name.trim()) err.name = "Business name is required.";
    if (!form.subscriptionId.trim()) err.subscriptionId = "Subscription plan is required.";
    if (!form.contactNo.trim()) err.contactNo = "Contact number is required.";
    else if (!isValidMobileNumber(form.contactNo.trim())) err.contactNo = "Enter a valid phone number.";
    if (!form.email.trim()) err.email = "Email is required.";
    else if (!isValidEmail(form.email.trim())) err.email = "Enter a valid email address.";
    setErrors(err);
    
    onSave("businessDetails", form, "isBusinessDetailsValid", Object.keys(err).length === 0, 'summary-details');
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (!validate()) return;
    if (typeof onNext === "function") onNext(form);
  };

  return (
    <form onSubmit={handleSubmit} className="w-full mx-auto bg-white dark:bg-gray-900 rounded-xl shadow-lg p-6 space-y-6">
      <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">Business details</h2>
      <p className="text-sm text-gray-600 dark:text-gray-300">Enter business details.</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">Business name</label>
          <input
            type="text"
            value={form.name}
            onChange={handleChange("name")}
            aria-invalid={!!errors.name}
            aria-describedby={errors.name ? "name-error" : undefined}
            className={`w-full rounded-md border px-3 py-2 text-sm bg-white dark:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-primary/50 ${errors.name ? "border-red-500" : "border-gray-300 dark:border-gray-700"}`}
            placeholder="Joe's car wash"
          />
          {errors.name && <p id="name-error" className="mt-1 text-sm text-red-600">{errors.name}</p>}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">Subscription Plan</label>
          <select
            type="text"
            //value={form.subscriptionId}
            onChange={handleChange("subscriptionId")}
            aria-invalid={!!errors.subscriptionId}
            aria-describedby={errors.subscriptionId ? "subscriptionId-error" : undefined}
            className={`w-full rounded-md border px-3 py-2 text-sm bg-white dark:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-primary/50 ${errors.subscriptionId ? "border-red-500" : "border-gray-300 dark:border-gray-700"}`}
            placeholder="Starter Plan"
            defaultValue={form.subscriptionId}
          >
            <option value="">Select a plan</option>
            {subscriptionPlans.map((plan) => (
              <option key={plan.id} value={plan.id}>{plan.name}</option>
            ))}
          </select>
          {errors.subscriptionId && <p id="subscriptionId-error" className="mt-1 text-sm text-red-600">{errors.subscriptionId}</p>}
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">Contact number</label>
          <input
            type="tel"
            value={form.contactNo}
            onChange={handleChange("contactNo")}
            aria-invalid={!!errors.contactNo}
            aria-describedby={errors.contactNo ? "contactNo-error" : undefined}
            className={`w-full rounded-md border px-3 py-2 text-sm bg-white dark:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-primary/50 ${errors.contactNo ? "border-red-500" : "border-gray-300 dark:border-gray-700"}`}
            placeholder="0820000000"
          />
          {errors.contactNo && <p id="contactNo-error" className="mt-1 text-sm text-red-600">{errors.contactNo}</p>}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">Email</label>
          <input
            type="email"
            value={form.email}
            onChange={handleChange("email")}
            aria-invalid={!!errors.email}
            aria-describedby={errors.email ? "email-error" : undefined}
            className={`w-full rounded-md border px-3 py-2 text-sm bg-white dark:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-primary/50 ${errors.email ? "border-red-500" : "border-gray-300 dark:border-gray-700"}`}
            placeholder="you@example.com"
          />
          {errors.email && <p id="email-error" className="mt-1 text-sm text-red-600">{errors.email}</p>}
        </div>
      </div>

      <div className="flex items-center justify-between gap-3">
        <button
          type="button"
          onClick={()=> onBack()}
          className="px-4 py-2 rounded-md bg-gray-200 hover:bg-gray-300 text-gray-800 dark:bg-gray-800 dark:text-gray-200 transition"
        >
          Back
        </button>

        <button
          type="submit"
          className="px-4 py-2 rounded-md bg-primary text-white hover:bg-primary/90 transition"
        >
          Next
        </button>
      </div>
    </form>
  );
};

export default BusinessDetailsTab;